<template>
  <div id="HomeSolutions">
    <div class="container">
      <div class="title">Our Solutions</div>
      <div class="body">
        <article>
          <div class="content solution-01">
            <div class="summary">Digital Strategy &amp; Solutions</div>
            <div class="mob">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-business/"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
            <div class="button">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-business/"
                target="_blank"
              >
                <button class="button-28 hover-white" role="button">
                  FIND OUT MORE
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </article>
        <article>
          <div class="content solution-02">
            <div class="summary">Management Platforms</div>
            <div class="mob">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-application-services-sap/"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
            <div class="button">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-application-services-sap/"
                target="_blank"
              >
                <button class="button-28 hover-white" role="button">
                  FIND OUT MORE
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </article>
        <article>
          <div class="content solution-03">
            <div class="summary">Enhanced Performance &amp; Support</div>
            <div class="mob">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-operations-ams/"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
            <div class="button">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-operations-ams/"
                target="_blank"
              >
                <button class="button-28 hover-white" role="button">
                  FIND OUT MORE
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </article>
        <article>
          <div class="content solution-04">
            <div class="summary">Process Automation &amp; Optimization</div>
            <div class="mob">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-operations-automation-center/"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
            <div class="button">
              <a
                href="https://www.meta.com.br/en/solucoes/digital-operations-automation-center/"
                target="_blank"
              >
                <button class="button-28 hover-white" role="button">
                  FIND OUT MORE
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </article>
      </div>
      <div class="footer">
        <div class="text">
          Meta DXi is a digital transformation data platform built for learning
          from the market. Be part of it.
        </div>
        <div class="button">
          <a href="https://www.meta.com.br/en/" target="_blank">
            <button class="button-28" role="button">
              VISIT OUR WEBSITE
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 orange"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSolutions",
  components: {},
};
</script>
